import { usePageGenerationPreviewStreaming } from 'hooks/use-page-generation-preview-streaming';

interface UsePreviewStreamingOptions {
  /** Resets stream state when the selected email or channel changes. */
  previewKey: number;
  streaming?: boolean;
  token?: string;
  channelName?: string;
  shouldFilterByPromptId?: boolean;
  previewContent?: unknown;
  onPostStream?: (content: unknown) => void;
}

const EMAIL_PREVIEW_LOG_CONTEXT = {
  thinkingStreamFailed: 'Email page preview thinking stream failed',
  htmlFormattingTokensFailed:
    'Failed to fetch HTML formatting tokens for email preview',
  postProcessingFailed: 'Email page preview post-processing failed',
} as const;

export const usePreviewStreaming = ({
  previewKey,
  streaming = true,
  token,
  channelName,
  shouldFilterByPromptId = true,
  previewContent,
  onPostStream,
}: UsePreviewStreamingOptions) => {
  return usePageGenerationPreviewStreaming({
    resetKey: previewKey,
    streaming,
    token,
    channelName,
    previewContent,
    shouldFilterByPromptId,
    onPostStream,
    logContext: EMAIL_PREVIEW_LOG_CONTEXT,
    step: 'SECTION_PROCESSED',
  });
};
